import React from 'react'
import {Route,Routes,HashRouter,Navigate} from "react-router-dom"
// import App from './App';
// import { NavBar, Space, Toast } from 'antd-mobile'
import Page01 from './Pages/Page01'
export default function Mrouter() {

 /*  let navigate = useNavigate();

  const back=()=>{
    navigate(-1)
  } */

  return (
    <>
    
     <HashRouter>
      <Routes>
        <Route path="/" element={<Page01 />}></Route>
        <Route path="/*" element={<Navigate to='/' />}></Route>

      </Routes>
    </HashRouter>
    </>
  
  );
}

